import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const a=t("western_union",i`
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            static
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_5837_339)">
                <mask
                    id="mask0_5837_339"
                    style="mask-type:alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24">
                    <circle
                        cx="12"
                        cy="12"
                        r="12"
                        fill="#FCFCFC" />
                </mask>
                <g mask="url(#mask0_5837_339)">
                    <path
                        d="M0 0H24V24H0V0Z"
                        fill="#FFDD00" />
                    <path
                        d="M2 7.00125C3.64586 6.99875 5.29298 7.00125 6.9401 7C8.67378 9.99818 10.4075 12.9976 12.1386 15.9971C11.9291 16.3546 11.7234 16.7159 11.5126 17.0734C11.2379 17.5288 10.8666 17.949 10.3786 18.1811C10.0098 18.358 9.57448 18.3969 9.18309 18.2689C8.72145 18.1271 8.3426 17.796 8.05407 17.4184C7.87342 17.1901 7.73794 16.9316 7.59117 16.682C5.72828 13.4542 3.86163 10.229 2 7.00125ZM8.57091 7.00125C10.218 7 11.8651 7.00125 13.511 7C14.6639 8.98833 15.8142 10.9779 16.9646 12.9663C17.0373 13.0879 17.1 13.2184 17.1954 13.3238C17.4174 13.5797 17.785 13.7026 18.1149 13.6148C18.3671 13.5546 18.5766 13.3777 18.7133 13.162C17.5278 11.1071 16.3398 9.05482 15.1544 7.00125C16.8015 7 18.4473 7 20.0945 7.00125C20.7292 8.10393 21.3652 9.20536 22 10.308C20.7041 12.5523 19.407 14.7953 18.1111 17.0395C17.8552 17.4711 17.519 17.87 17.0775 18.1196C16.7074 18.3341 16.252 18.4081 15.8368 18.2952C15.3626 18.1723 14.9687 17.8474 14.6701 17.4698C14.4606 17.2151 14.3089 16.9216 14.1433 16.6381C12.2866 13.4254 10.4275 10.2139 8.57091 7.00125Z"
                        fill="black" />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_5837_339">
                    <rect
                        width="24"
                        height="24"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{a as WesternUnion};
